export default {
  common: {
    welcomeToGravy: 'Bienvenido a Gravy',
    send: 'Enviar',
    yes: 'Si',
    no: 'No'
  },
  ref: {
    endorse: 'Avala a tu Colega!',
    complete: 'Tu respuesta ha sido guardada!',
    supervisor: {
      q1: '¿_worker_est· disponible para volver a contratar?',
      q2: '¿Tuvo _worker_ un traslado lateral o ascenso en el tiempo que trabajÛ contigo?',
      q3: '¿Hizo _worker_ lo mÌnimo que el trabajo requerÌa o fue m·s all· de eso e hizo un trabajo superior?',
      q4: '¿Fue en alg˙n momento _worker_ disciplinado(a) por tardanza o ausencia?',
      q5: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en el ·rea de resoluciÛn de conflictos?',
      q6: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ como lÌder?',
      q7: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en el ·rea de atenciÛn al cliente?',
      q8: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en tÈrminos de su habilidad de comunicarse efectivamente (por medio de correo electrÛnico, memor·ndum, etc).?',
      q9: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en su habilidad de presentarse de forma profesional verbalmente y de forma no verbal?'
    },
    coWorker: {
      q1: '¿Fue un placer trabajar con _worker_?',
      q2: '¿Hizo _worker_ lo mÌnimo que el trabajo requerÌa o fue m·s all· de eso e hizo un trabajo superior?',
      q3: '¿Fue _worker_ un trabajador que apreciaba el trabajo en equipo?',
      q4: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en el ·rea de resoluciÛn de conflictos?',
      q5: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ como lÌder?',
      q6: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en el ·rea de atenciÛn al cliente?',
      q7: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en tÈrminos de su habilidad de comunicarse efectivamente (por medio de correo electrÛnico, memor·ndum, etc).?',
      q8: '¿En una escala del 1 al 10, que calificaciÛn le darÌas a _worker_ en su habilidad de presentarse de forma profesional verbalmente y de forma no verbal?'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/translations/es.js